// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__X1SLxtZR","warning":"SignUpIncorrectBirthStep_warning__rfTRkf-e","back":"SignUpIncorrectBirthStep_back__w9x7MKPk"};